// reducers/index.js
import { combineReducers } from 'redux';
import appReducer from './appreducer';
import uploadReducer from './uploadReducer';

// Combine all reducers
const rootReducer = combineReducers({
  appreducer: appReducer,
  uploadReducer: uploadReducer,
});

export default rootReducer;
